import { useGetWebsiteConfig } from '@/hooks/use-configuration'
import Image from 'next/image';
import Link from 'next/link';
import React from 'react'

const WebLogo = () => {
  const {data: websiteConfig, isLoading} = useGetWebsiteConfig();
  
  const logoSrc = websiteConfig?.logo || '/default-logo.webp'; 
   
  return (
    <>
    <Link href='/flight' className='flex items-center justify-center'>
    <Image
      src={logoSrc}
      alt="Logo"
      width={150}
      height={20}
      layout="fixed" 
      priority     
    />
    {websiteConfig?.mode==='development' && <p className='bg-red-600 text-whtie rounded-xl text-xs p-1'>{websiteConfig?.mode==='development' && 'Development'}</p>}
    </Link>
    </>
  )
}

export default WebLogo